<div class="verification-container" *ngIf="!user">
  <p class="error-text">
    {{ errorMessage || "El enlace ha expirado y no es válido." }}
  </p>
</div>
<div class="verification-container" *ngIf="user">
  <h2 class title="verification-title">Crear nueva contraseña</h2>
  <div class="email-notification">
    <p>
      Hola <strong>{{ user?.name }}</strong>,
    </p>
    <p>
      Tu contraseña debe ser diferente a las anteriores que haz usado. Utiliza
      al menos 8 caracteres, mayúsculas y símbolos.
    </p>
  </div>

  <form [formGroup]="form" (ngSubmit)="resetPassword()">
    <div class="password-input-container">
      <input [type]="showPassword ? 'text' : 'password'" placeholder="Contraseña nueva" formControlName="password" maxlength="16" (input)="checkPassword($event, 'password-pointer')" name="password" />
      <button type="button" class="password-toggle-btn" (click)="togglePasswordVisibility()" tabindex="-1">
        <!-- Icono ojo abierto -->
        @if (showPassword) {
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-eye-icon lucide-eye">
          <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" />
          <circle cx="12" cy="12" r="3" />
        </svg>
        }@else {<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-eye-off-icon lucide-eye-off">
          <path d="M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49" />
          <path d="M14.084 14.158a3 3 0 0 1-4.242-4.242" />
          <path d="M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143" />
          <path d="m2 2 20 20" />
        </svg>}
      </button>
    </div>
    <div *ngIf="password?.value && password?.value.length >= 8" class="password-strong-container">
      <div #pointer id="password-pointer"></div>
    </div>

    <div class="password-input-container">
      <input [type]="showConfirmPassword ? 'text' : 'password'" placeholder="Confirmar contraseña nueva" formControlName="confirmPassword" maxlength="16" (input)="checkPassword($event, 'confirm-password-pointer')" name="confirmPassword" />
      <button type="button" class="password-toggle-btn" (click)="toggleConfirmPasswordVisibility()" tabindex="-1">
        @if (showConfirmPassword) {
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-eye-icon lucide-eye">
          <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" />
          <circle cx="12" cy="12" r="3" />
        </svg>
        }@else {<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-eye-off-icon lucide-eye-off">
          <path d="M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49" />
          <path d="M14.084 14.158a3 3 0 0 1-4.242-4.242" />
          <path d="M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143" />
          <path d="m2 2 20 20" />
        </svg>}
      </button>
    </div>
    <div *ngIf="confirmPassword?.value && confirmPassword?.value.length >= 8" class="password-strong-container">
      <div #pointer id="confirm-password-pointer"></div>
    </div>
    <div *ngIf="form.errors?.['mismatch'] && confirmPassword?.touched" class="validation-input-error email-exist">
      Las contraseñas no coinciden
    </div>
    <div *ngIf="errorMessage" class="validation-input-error general-error">
      {{ errorMessage }}
    </div>

    <div class="button-verificar">
      <button class="boton-principal" [disabled]="form.invalid" type="submit">
        Guardar nueva contraseña
      </button>
    </div>
  </form>
</div>